import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import { SelectedAgent } from './AgentActionMenu.types';
import AgentBulkActionMenuWindows from './AgentTable/components/AgentBulkActionMenu/OS/AgentBulkActionMenu.windows.vue';
import AgentBulkActionMenuLinux from './AgentTable/components/AgentBulkActionMenu/OS/AgentBulkActionMenu.linux.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentBulkActionMenu',
  props: {
    modelValue: { type: Boolean },
    agents: null,
    beforeHide: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: boolean | undefined): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  agents: SelectedAgent[];
  beforeHide?: () => void;
}

const osService = useOsService();


const menuOptions = computed(() => ({
  attrs: {
    offset: [-97, -38],
    self: 'top left',
    anchor: 'top right',
    rootClass: 'incredi-q-menu incredi-q-menu-agents',
    activeClass: 'incredi-q-item-active',
    'context-menu': props.modelValue,
  },
  listeners: {
    'before-hide': props.beforeHide,
  },
}));

// eslint-disable-next-line no-unused-vars


return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(AgentBulkActionMenuWindows, {
        key: 0,
        target: ".bulk-actions-btn",
        "menu-options": _unref(menuOptions),
        agents: __props.agents,
        "model-value": __props.modelValue,
        "data-testid": _unref(elementsIds).agents.AgentsBulkActionMenuList.listWindows,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (newVal) => emit('update:model-value', newVal))
      }, null, 8, ["menu-options", "agents", "model-value", "data-testid"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(AgentBulkActionMenuLinux, {
          key: 1,
          target: ".bulk-actions-btn",
          "menu-options": _unref(menuOptions),
          agents: __props.agents,
          "model-value": __props.modelValue,
          "data-testid": _unref(elementsIds).agents.AgentsBulkActionMenuList.listLinux,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (newVal) => emit('update:model-value', newVal))
        }, null, 8, ["menu-options", "agents", "model-value", "data-testid"]))
      : _createCommentVNode("", true)
}
}

})